import { browser } from '$app/environment';
import type { CartItemFrom } from '$lib/models/cart-item';
import { showTrialModal, trialModalPremium, trialModalFrom, trialModalAnnual } from '$lib/stores/modals';

export function startTrialFlow(addedFrom: CartItemFrom, premium: boolean = true, annual: boolean = true) {
  if (!browser) return;
  trialModalFrom.set(addedFrom);
  trialModalPremium.set(premium);
  trialModalAnnual.set(annual);
  showTrialModal.set(true);
}
